import { Icon, IconProps } from '@chakra-ui/react'

export default function MedicalCrossIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M16 21.5H18C19.6569 21.5 21 20.1569 21 18.5V16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 3.5H18C19.6569 3.5 21 4.84315 21 6.5V8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.5V18.5C3 20.1569 4.34315 21.5 6 21.5H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 8.5V6.5C3 4.84315 4.34315 3.5 6 3.5H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 14.5V16.25C14 16.9404 13.4404 17.5 12.75 17.5H11.25C10.9185 17.5 10.6005 17.3683 10.3661 17.1339C10.1317 16.8995 10 16.5815 10 16.25V14.5H8.25C7.55964 14.5 7 13.9404 7 13.25V11.75C7 11.4185 7.1317 11.1005 7.36612 10.8661C7.60054 10.6317 7.91848 10.5 8.25 10.5H10V8.75C10 8.05964 10.5596 7.5 11.25 7.5H12.75C13.4404 7.5 14 8.05964 14 8.75V10.5H15.75C16.4404 10.5 17 11.0596 17 11.75V13.25C17 13.9404 16.4404 14.5 15.75 14.5H14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
